import { graphql } from '@/client/services/api/graphql/gql';

export const listUserAIConversationsQuery: any = graphql(`
  query ListUserAIConversations(
    $channel: StringQueryOperatorArgs
    $includeTotalCount: Boolean! = true
    $ordering: [OrderBy!]
    $page: Int! = 0
    $pageSize: Int! = 50
    $search: StringQueryOperatorArgs
  ) {
    listUserConversations(
      channel: $channel
      includeTotalCount: $includeTotalCount
      ordering: $ordering
      page: $page
      pageSize: $pageSize
      search: $search
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        totalCount
      }
      edges {
        node {
          channel
          conversation
          createdAt
          id
          query
          references {
            contentId
            contentType
            sourceType
          }
          response
          sessionId
          threadId
        }
      }
    }
  }
`);
